import { useContext } from "react";
import { useHistory } from "react-router-dom";
import Flows from "../../assets/images/flows1.svg";

import DropdownSelect from "./DropdownSelect";
import { UserContext } from "./UserContext";
import "./index.css";

import { Image } from "react-bootstrap";
import logout from "../../assets/images/logout.svg";
import NotificationBell from "../Notifications/NotificationBell";
import AppSwitcher from "./AppSwitcher1";

function TopBar1() {
  const { name, role } = useContext(UserContext);
  const history = useHistory();

  const logoutHandler = () => {
    localStorage.clear();
    history.push("/login");
  };
  let formattedName: string = name
    .split(/\s/)
    .reduce((response, word) => response + word.slice(0, 1), "")
    .toUpperCase();
  formattedName =
    formattedName.length === 1
      ? name.substring(0, 2).toUpperCase()
      : formattedName;
  const array = [
    {
      name: role,
    },
    {
      name: "Logout",
      image: logout,
      clickEvent: logoutHandler,
    },
  ];

  return (
    <>
      <div className="top-bar-height1 shadow-sm d-flex align-items-center">
        <Image
          className="logo"
          src={Flows}
          style={{ margin: "1%", width: "30px" }}
        />
        <span style={{ color: "white", fontSize: "20px" }}>Orchestrator</span>
        <div className="user-name">
          <div style={{ padding: "15px", cursor: "pointer" }}>
            <NotificationBell />
          </div>
          {/* {name.charAt(0).toUpperCase() + name.substring(1)} */}

          <div style={{ padding: "15px", cursor: "pointer" }}>
            <AppSwitcher />
          </div>
        </div>
        <DropdownSelect
          data={formattedName}
          role={array}
          className="rounded-circle p-2"
        />
      </div>
    </>
  );
}
export default TopBar1;
